import { render, staticRenderFns } from "./CommunicationListPanel.vue?vue&type=template&id=75fec814"
import script from "./CommunicationListPanel.vue?vue&type=script&lang=js"
export * from "./CommunicationListPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports